import { IProduct } from '../../../interfaces/catalog'
import { MapProps } from '../../../interfaces/mappedProps'
import { deepMerge } from '../../../utils/deepMerge'
import { TagItemProps, TagsProps } from '../Tags'
import { itemCardLayouts } from './ItemCard.defaultProps'
import { ItemCardProps } from './ItemCard.types'

/**
 * Process an Array of string with key values to returns an Array of object with ItemTags props
 * @param data Data of the item
 * @param valuesMap Map of objects to match the keys of tags and get default props
 * @param tags Array of strings
 */
export const getMappedTagsProps = (tags: MapProps<TagsProps>[]) => {
  return tags.map(({ props }) => {
    return props
  }) as unknown as TagItemProps[]
}

/**
 * Create a deep merge between component default props and custom props
 * @param props - new props to be merged
 * @param layout  - layout name to get default props
 * @returns
 */
export const mergeItemCardProps = (
  props: Partial<ItemCardProps>,
  layout: ItemCardProps['layout'] = 'none'
) => deepMerge(itemCardLayouts[layout], props)

/**
 * Validate variable values in ItemCard to update the component
 * Returns false if component has to be updated
 */
export const validateMemo = (
  oldProps: ItemCardProps,
  newProps: ItemCardProps
) => {
  const stock = oldProps.item?.stock === newProps.item?.stock
  const quantity = oldProps.item?.quantity === newProps.item?.quantity
  const promotions =
    oldProps.item?.promotion?.label === newProps.item?.promotion?.label &&
    oldProps.item?.promotion?.value === newProps.item?.promotion?.value
  const subItemsProducts =
    oldProps.item?.subItemsProduct?.reduce(
      (acc, item) => item.quantity + acc,
      0
    ) ===
    newProps.item?.subItemsProduct?.reduce(
      (acc, item) => item.quantity + acc,
      0
    )
  const layout = oldProps.layout === newProps.layout
  const itemsExtra = oldProps.item?.itemsExtra === newProps.item?.itemsExtra
  if (oldProps.noMemoize || newProps.noMemoize) return false
  return (
    quantity && layout && promotions && stock && subItemsProducts && itemsExtra
  )
}

/**
 *
 * Returns the price per package type
 * if the packageType is not available, it will return the price
 */
export const getPricePerPackageType = (
  item: IProduct,
  map: Record<string, string>
) => {
  const { packageType, price, packagePrice } = item

  if (packagePrice !== undefined) {
    return packagePrice
  }

  if (packageType) {
    const priceName = map[packageType] || map[packageType.toLowerCase()]

    if (priceName && item[priceName] !== undefined) {
      return item[priceName]
    }
  }

  return price
}
